import React, { useState, useEffect } from "react";
import AOS from "aos";
import "../css/ProjectsPage.css";
import Footer from "./Footer";
import Navbar from "./Navbar";
import "aos/dist/aos.css";
import { Link } from "react-router-dom";
import { Helmet } from 'react-helmet';


const ProjectsPage = () => {
  const [activeFilter, setActiveFilter] = useState("all");

  const projects = [
    {
      id: 1,
      title: "Sooch E-commerce Platform",
      description: "Scalable e-commerce with inventory management",
      category: "web",
      technologies: ["Laravel", "MySQL", "Tailwind"],
      image:
        "https://cdn.dribbble.com/userupload/35747943/file/original-cb8a34bed21d68fa9982f10a126c8c6f.png?format=webp&resize=400x300&vertical=center",
      liveLink: "#",
      status: "Live",
    },
    {
      id: 2,
      title: "Attedify Attendance System App",
      description: "Secure Attendance with punch + face authentication",
      category: "mobile",
      technologies: ["React", "Firebase", "Flutter"],
      image: "https://www.digisme.in/contents/images/phoneimage_oneapptgt.webp",
      liveLink: "#",
      status: "Development",
    },
    {
      id: 3,
      title: "Female Care App",
      description:
        "Designed to support women's health, wellness, and lifestyle management.",
      category: "iot",
      technologies: ["Flutter", "Laravel", "MySQL", "Firebase"],
      image:
        "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTD_lUSyrRAxiLwl3U6lzvcsHLqW-gK8Mx69A&s",
      liveLink: "#",
      status: "Live",
    },
    {
      id: 4,
      title: "Employee Management System ( LMS )",
      description:
        "System built with Laravel for seamless staff tracking, attendance, and payroll management",
      category: "web",
      technologies: ["Bootstrap", "Laravel", "MySQL"],
      image:
        "https://i.pinimg.com/736x/11/81/1f/11811f1fb5dc360e122452ced1039ba1.jpg",
      liveLink: "#",
      status: "Development",
    },
    {
      id: 5,
      title: "Expense Locator App",
      description:
        "Smart Expense Locator App that tracks, categorizes, and visualizes your spending with real-time location insights.",
      category: "mobile",
      technologies: ["Flutter", "Firebase", "MySQL"],
      image:
        "https://i.pinimg.com/736x/81/a5/7a/81a57a98b3ee593bfbb10fd0d1eeb9d5.jpg",
      liveLink: "#",
      status: "Live",
    },
  ];

  const categories = [
    { id: "all", name: "All" },
    { id: "web", name: "Web" },
    { id: "mobile", name: "Mobile" },
    { id: "ai", name: "AI" },
    { id: "iot", name: "IoT" },
  ];

  const filteredProjects =
    activeFilter === "all"
      ? projects
      : projects.filter((project) => project.category === activeFilter);

  useEffect(() => {
    AOS.init({ duration: 1000, once: true });
  }, []);

  return (
    <div>
      <Helmet>
        <title>Projects | TechSol Technologies</title>
        <meta
          name="description"
          content="Get in touch with TechSol Technologies for inquiries, support, or feedback."
        />
      </Helmet>
      <Navbar />
      {/* Enhanced Hero Section */}
      <section className="contact-hero" data-aos="fade-up">
        <div className="hero-background">
          <div className="hero-glow"></div>
        </div>
        <div className="container">
          <div className="hero-content text-center">
            <h1 className="hero-title">
              Our <span className="gradient-text">Projects</span>
            </h1>
            <p className="hero-subtitle">
              Innovative solutions driving digital transformation across
              industries
            </p>
            <div className="breadcrumb">
              <Link to="/" className="breadcrumb-link">
                Home
              </Link>
              <span className="breadcrumb-separator"> / </span>
              <span className="breadcrumb-active">Projects</span>
            </div>
          </div>
        </div>
      </section>
      <div className="projects-page container">
        {/* Compact Filter */}
        <div className="compact-filter">
          <div className="filter-tabs">
            {categories.map((category) => (
              <button
                key={category.id}
                className={`tab ${
                  activeFilter === category.id ? "active" : ""
                }`}
                onClick={() => setActiveFilter(category.id)}
              >
                {category.name}
              </button>
            ))}
          </div>
        </div>

        {/* Compact Projects Grid */}
        <div className="compact-projects">
          {filteredProjects.map((project) => (
            <div key={project.id} className="project-card-compact">
              <div className="project-image-compact">
                <img src={project.image} alt={project.title} />
                <div className="project-status">
                  <span className={`status ${project.status.toLowerCase()}`}>
                    {project.status}
                  </span>
                </div>
              </div>

              <div className="project-content-compact">
                <div className="project-header-compact">
                  <h3>{project.title}</h3>
                  <button
                    className="live-link-btn"
                    onClick={() => window.open(project.liveLink, "_blank")}
                  >
                    Visit Live
                    <svg
                      width="14"
                      height="14"
                      viewBox="0 0 24 24"
                      fill="currentColor"
                    >
                      <path d="M14 3h7a1 1 0 0 1 1 1v7h-2V5h-6V3z" />
                      <path d="M5 5v14h14v-7h2v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h7v2H5z" />
                    </svg>
                  </button>
                </div>

                <p className="project-desc-compact">{project.description}</p>

                <div className="project-tech-compact">
                  {project.technologies.map((tech, index) => (
                    <span key={index} className="tech-pill">
                      {tech}
                    </span>
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Minimal CTA */}
        <div className="minimal-cta">
          <div className="cta-content">
            <h3>Start Your Project Today</h3>
            <Link to="/contact">
              <button className="cta-btn">Get Free Consultation</button>
            </Link>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default ProjectsPage;
